module.exports = __webpack_public_path__ + "static/media/photographyEvent.0e05e23e.jpg";